import '../../scss/parts/ratePageTemplate.scss';
import rateConverterWidget from "../widgets/coin-courses/widget-converter.js";
import priceChart from "../widgets/priceChart.js";
import coinInfo from '../widgets/coin-courses/coinInfo.js';
import coinTopExchanges from '../widgets/coin-courses/coinTopExchanges.js'
import coinShortInfo from '../widgets/coin-courses/coinShortInfo.js';
import coinFaq from '../widgets/coin-courses/coinFaq.js'
import coinConvertationInstruction from '../widgets/coin-courses/coinConvertationInstruction.js';
import coinCurrentRate from '../widgets/coin-courses/coinCurrentRate.js';
import coinConvertationTable from '../widgets/coin-courses/coinConvertationTable.js';

(function ($) {
    $(async function () {
        window.$ = jQuery;
        await rateConverterWidget.init();
        priceChart.init();
        priceChart.drawChart('chartWeekAgo');
        await coinInfo.updateDynamicsData();
        await coinTopExchanges.updateDynamicsData();
        await coinShortInfo.updateDynamicsData();
        await coinFaq.updateDynamicsData();
        await coinCurrentRate.updateDynamicsData();
        await coinConvertationTable.updateDynamicsData();
        await coinConvertationInstruction.updateDynamicsData();
    });
}(jQuery));
